<template>
  <div v-if="
  this.enableAccessAuthCreate('A1', this.getUser.pref.select.cauth) === true">
    <v-btn v-if="this.data.btn === 'icon'"
    icon @click="openDialog()">
      <v-icon :color="ui.btnColor">
        add
      </v-icon>
    </v-btn>
    <v-btn v-if="this.data.btn === 'flat'"
    :color="ui.btnColor" flat dark @click="openDialog()">
      <v-icon left>
        add
      </v-icon>
      New
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor">
              {{assetObj.icon}}
            </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                {{assetObj.heading}}
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="asset full name"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.tag"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="asset tag"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.assetTypeSelection"
                    :items="assetType"
                    color="wplblue0"
                    prepend-icon="grid_view"
                    hint="asset type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_transportation </v-icon>
                  </v-avatar>
                  Asset Type Selection {{this.localForm.assetTypeSelection}}
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2">
                <div :class="ui.textSubheading"
                v-if="this.localForm.assetTypeSelection === 'TA1'">
                  {{ this.assetTypeDescription[0].des }}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2">
                <div :class="ui.textSubheading"
                v-if="this.localForm.assetTypeSelection === 'TA2'">
                  {{ this.assetTypeDescription[1].des }}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2">
                <div :class="ui.textSubheading"
                v-if="this.localForm.assetTypeSelection === 'TA3'">
                  {{ this.assetTypeDescription[2].des }}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2">
                <div :class="ui.textSubheading"
                v-if="this.localForm.assetTypeSelection === 'TA4'">
                  {{ this.assetTypeDescription[3].des }}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2">
                <div :class="ui.textSubheading"
                v-if="this.localForm.assetTypeSelection === 'TA5'">
                  {{ this.assetTypeDescription[4].des }}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2">
                <div :class="ui.textSubheading"
                v-if="this.localForm.assetTypeSelection === 'TA6'">
                  {{ this.assetTypeDescription[5].des }}
                </div>
              </v-layout>

              <div v-if="this.data.copy" class="mt-4">
                <v-layout class="text-xs-left ml-2 mr-2">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon :color="ui.colorWarning"> emoji_transportation </v-icon>
                    </v-avatar>
                    <div :class="ui.textWarning">
                      Asset Copy
                    </div>
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <div :class="ui.textWarning">
                      {{displayDocumentIDGTypeA(this.data.detail.basic.tag, this.data.detail.basic.idg)}}
                    </div>
                  </v-chip>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2 mt-4">
                  <v-flex xs11>
                    <v-text-field
                    :label="localForm.nameCopy"
                    prepend-icon="title"
                    hint="orginal asset name"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="localForm.tagCopy"
                    prepend-icon="fingerprint"
                    hint="original asset tag"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.itemEngineeringDiscipline"
                    :items="engineeringDiscipline"
                    color="wplblue0"
                    prepend-icon="engineering"
                    hint="engineering discipline"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.itemFunctionalObjective"
                    :items="assetFunctionalObjective"
                    color="wplblue0"
                    prepend-icon="adjust"
                    hint="funtcional objective"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-1 mr-1">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="asset description"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="general description for specific facility application"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_transportation  </v-icon>
                  </v-avatar>
                  Asset Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_transportation  </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Asset Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only"
              v-if="this.data.copy">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon :color="ui.colorWarning"> title </v-icon>
                  </v-avatar>
                  <div :class="ui.textWarning">
                    Copy Name
                  </div>
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <div :class="ui.textWarning">
                    {{localForm.nameCopy}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up"
              v-if="this.data.copy">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon :color="ui.colorWarning"> title </v-icon>
                  </v-avatar>
                  <div :class="ui.textWarning">
                    {{localForm.nameCopy}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only"
              v-if="this.data.copy">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon :color="ui.colorWarning"> fingerprint </v-icon>
                  </v-avatar>
                  <div :class="ui.textWarning">
                    Copy Tag
                  </div>
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <div :class="ui.textWarning">
                    {{localForm.tagCopy}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up"
              v-if="this.data.copy">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon :color="ui.colorWarning"> fingerprint </v-icon>
                  </v-avatar>
                  <div :class="ui.textWarning">
                    {{localForm.tagCopy}}
                  </div>
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Technical
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemEngineeringDiscipline}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  {{localForm.itemEngineeringDiscipline}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Function
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.itemFunctionalObjective}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  {{localForm.itemFunctionalObjective}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            <v-icon left> navigate_next </v-icon>
            Next
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          class="hidden-sm-and-up"
          @click="nextStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createNewAsset()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createNewAsset()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import selectAsset from "@/data/options/mixins/selectAsset.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";

import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    facilityOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    selectAsset,
    techOptions,
    displayFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        nameCopy: "",
        tag: "",
        tagCopy: "",
        itemFunctionalObjective: "",
        itemEngineeringDiscipline: "",
        assetTypeSelection: "TA4",
        des: ""
      },
      info: [
        {
          step: 0,
          title: "Asset Setup",
          // eslint-disable-next-line
          msg: "Asset is a physical object that can be installed, tested, operated and maintained to ensure its design function integrity for total life cycle of the facility. Multiple assets working together form a unit or system or facility where the asset design operations create a business value.",
          icon: ""
        },
        {
          step: 1,
          title: "Critical Asset Info",
          // eslint-disable-next-line
          msg: "Asset is part of the facility and as minimum must have a title and software tag which is also a physical tag that can be identified in the field. The title and tag must be unique at the facility level. The internal business process should define the preferred naming and tagging convention for the assets which are strongly linked to facility naming convention.",
          icon: ""
        },
        {
          step: 2,
          title: "Basic Asset Info",
          // eslint-disable-next-line
          msg: "Asset is a physical item which includes facility, maintenance and technical data to enable business operation. The functional purpose is technical primary objective of the asset, why was the asset installed at the facility.",
          error: "",
          icon: ""
        },
        {
          step: 3,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. If you need to edit then return to previous steps. Admin will verify your request and activate the facility.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser", "getFacility"]),
    assetObj() {
      let obj = {
        heading: "",
        icon: ""
      };
      if (this.data.copy === true) {
        obj.heading = "Asset Copy";
        obj.icon = "content_copy";
      } else {
        obj.heading = "New Asset";
        obj.icon = "add";
      }
      return obj;
    },
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 3 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.name !== "" &&
        this.localForm.tag !== ""
      ) {
        logic = true;
      } else if (
        this.step == 2 &&
        this.localForm.des !== "" &&
        this.localForm.itemFunctionalObjective !== "" &&
        this.localForm.itemEngineeringDiscipline !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      // download facility which is used for asset
      this.getDocumentFacilityOnly(this.getUser.pref.select.fdid);
      // Original Asset name
      if (this.data.copy === true) {
        this.localForm.nameCopy = this.data.detail.basic.title;
        this.localForm.tagCopy = this.data.detail.basic.id;
        // GENERATE INFO
        // eslint-disable-next-line
        this.localForm.name = this.generateNextSeriesText(this.data.detail.basic.title);
        // eslint-disable-next-line
        this.localForm.tag = this.generateNextSeriesText(this.data.detail.basic.id);
        this.localForm.itemFunctionalObjective = this.data.detail.char.obj;
        this.localForm.itemEngineeringDiscipline = this.data.detail.char.dis;
        this.localForm.des = this.data.detail.char.des;
      }
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewAsset() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "A1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateAssetForm(); // form is from compnew component

      // BASIC Data
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.tag;

      // COPY DATA from other Asset
      if (this.data.copy === true) {
        temp.char = this.data.detail.char;
      }

      // CHAR Data
      temp.char.dis = this.localForm.itemEngineeringDiscipline;
      temp.char.obj = this.localForm.itemFunctionalObjective;
      temp.char.des = this.localForm.des;
      temp.char.type = this.localForm.assetTypeSelection;

      // STATS
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // CREATE ASSET
      this.createFirebaseDocumentOnly(temp);

      // HELP
      // console.log(">>> NEW ASSET <<<");
      // console.log(temp);
    }
  }
};
</script>
